module.exports = __webpack_public_path__ + "img/curtains.4aa15122.png";